import script from "./sf-table-header-cell.vue?vue&type=script&setup=true&lang=ts&generic=HD%20extends%20BaseHeader"
export * from "./sf-table-header-cell.vue?vue&type=script&setup=true&lang=ts&generic=HD%20extends%20BaseHeader"

import "./sf-table-header-cell.vue?vue&type=style&index=0&id=f3cf1d5b&lang=scss"

const __exports__ = script;

export default __exports__